/**
 * getScrollBarSize
 * @class
 */
module.exports = (() => {
  return {
    getScrollBarSize: () => {
      return {
        x: parseFloat(window.innerWidth) - parseFloat(document.documentElement.clientWidth),
        y: parseFloat(window.innerHeight) - parseFloat(document.documentElement.clientHeight),
      }
    },
  }
})();



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/module/scrollbar-size.js
 **/